export default "__VITE_PUBLIC_ASSET__30377b3a__"